import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Industries from "../components/Industries";
import Process from "../components/Process";
import WhyUs from "../components/WhyUs";
import TrustReasons from "../components/TrustReasons";
import Security from "../components/Security";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <Services />
      <Industries />
      <Process />
      <WhyUs />
      <TrustReasons />
      <Security />
      <FAQ />
      <Contact />
      <FinalCTA />
    </main>
  );
}
